import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { MemberService } from "app/member/member.service";
import { ToastsManager } from 'ng2-toastr';
import { ActivatedRoute } from '@angular/router';
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { GridMetadataService } from "../clearwave-grid/grid.metadata.service";
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  public search = {
    LastName:'',
    FirstName:'',
    Email:'',
    Phones:[{Number: ''}],
    BarcodeId: ''
  }

  @ViewChild('memberDeleteModal') public memberDeleteModal: ModalDirective;

  public serviceStackUrl;
  public submitted = false;
  public searchResults = [];
  public searching: boolean = false;
  public MemberSearchResults;
  public numResults;
  public selectedRows = [];
  public confirmDelete = '';

  constructor(
    private _restService: RestService,
    private memberService: MemberService,
    private _toast: ToastsManager,
    private route: ActivatedRoute,
    private _router: Router,
    private _gridMetadataService: GridMetadataService,
    platformLocation: PlatformLocation
  ) {

    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';

    this.MemberSearchResults = this._gridMetadataService.describe('MemberSearchResults', null);
    this.MemberSearchResults.forceFitColumns = true;
    this.MemberSearchResults.height = -475;
    this.MemberSearchResults.completeGridEditDisabled = true;
    this.MemberSearchResults.disableRest = true;
    this.MemberSearchResults.onDblClick = this.goToMemberDetail.bind(this);
    this.MemberSearchResults.onSelectedRowsChanged = this.setSelectedRows.bind(this);
    
    this.memberService.foundMembers.subscribe(members => {
      if (Object.keys(members).length !== 0) {
        console.log(members);
        this.searchResults = members;
        this.submitted = true;
        if (this.submitted && this.searchResults.length) {
          this.MemberSearchResults.title = this.searchResults.length  + ' Result(s)';
          this.MemberSearchResults.data = this.searchResults;
          if (typeof this.MemberSearchResults.setData === "function") {
            this.MemberSearchResults.setData(this.searchResults);
          }
        }
      }
    });

  }

  ngOnInit() {
    this.memberService.foundMembers.next({});
  }

  clearAll() {
    this.search = {
      LastName:'',
      FirstName:'',
      Email:'',
      Phones:[{Number: ''}],
      BarcodeId: ''
    };
  }

  searchMembers() {
    this.searching = true;
    if (this.search.LastName.length) {
      this.search.LastName = "*" + this.search.LastName + "*";
    }
    if (this.search.FirstName.length) {
      this.search.FirstName = "*" + this.search.FirstName + "*";
    }
    if (this.search.Email.length) {
      this.search.Email = "*" + this.search.Email + "*";
    }
    console.log(this.search);
    let url = this.serviceStackUrl + "Member-GetMembersByQuery";
    this._restService.post(url, {EntityDto: this.search}).then(response => {
      console.log(response);
      this.search.LastName = this.search.LastName.substr(1).slice(0, -1);
      this.search.FirstName = this.search.FirstName.substr(1).slice(0, -1);
      this.search.Email = this.search.Email.substr(1).slice(0, -1);
      this.searching = false;
      this.searchResults = response.Data
      this.submitted = true;
      if (this.submitted && this.searchResults.length) {
        this.MemberSearchResults.title = this.searchResults.length  + ' Result(s)';
        this.MemberSearchResults.data = this.searchResults;
        if (typeof this.MemberSearchResults.setData === "function") {
          this.MemberSearchResults.setData(this.searchResults);
        }
      }
    })
  }

  validatePhone(phone) {
    if (this.memberService.formatPhone(phone) === false) {
      this._toast.error('Please enter a valid phone number');
      this.search.Phones[0].Number = '';
    } else {
      this.search.Phones[0].Number = this.memberService.formatPhone(phone);
    }
  }

  goToMemberDetail(e, args, row) {
    this._router.navigate(['/member/' + row.id]);
  }

  setSelectedRows(e, args) {
    this.selectedRows = [];
    for (let row of args.rows) {
      this.selectedRows.push(args.grid.getDataItem(row).Oid);
    }
  }

  deleteMember() {
    console.log("delete");
    if (this.selectedRows.length) {
      this.memberDeleteModal.show();
    }
  }

  confirmDeleteMember() {
    let url = this.serviceStackUrl + "Member-DeleteMember";
    if (this.confirmDelete === 'DELETE') {
      console.log("confirm delete");
      this._restService.post(url, { MemberOidList: this.selectedRows }).then(response => {
        this.memberDeleteModal.hide();
        if (response.Success) {
          this._toast.success(this.selectedRows.length + ' member(s) deleted successfully');
          this.selectedRows = [];
          this.confirmDelete = '';
          this.searchMembers();
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/search/search.component.ts